import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function OAuthCallback() {
  const location = useLocation();
  const [statusMessage, setStatusMessage] = useState(
    'Completing authorization, please wait...',
  );
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    // console.log('OAuth callback params:', { code, state, error });

    const postToOpener = (payload) => {
      // console.log('Posting message to opener:', payload);

      // 1. Try postMessage if opener exists
      if (window.opener) {
        // console.log('Sending message via postMessage');
        window.opener.postMessage(
          { type: 'CALENDLY_OAUTH', ...payload },
          window.location.origin,
        );
        return;
      }

      // 2. Fallback: store data in localStorage (same‑origin required)
      try {
        // console.log('Fallback: writing to localStorage');
        localStorage.setItem('oauth_callback_data', JSON.stringify(payload));
        // Also set a timestamp to signal fresh data
        localStorage.setItem('oauth_callback_timestamp', Date.now().toString());
      } catch (e) {
        // console.error('localStorage fallback failed:', e);
        // Optionally redirect to a page with error query param
      }
    };

    if (error) {
      postToOpener({ error });
      setHasError(true);
      setStatusMessage(
        'Authorization denied. Please close this window and try again.',
      );
      return;
    }

    if (!code) {
      postToOpener({ error: 'Missing authorization code' });
      setHasError(true);
      setStatusMessage(
        'Authorization failed: missing code. Please close this window.',
      );
      return;
    }

    postToOpener({ code, state });
    setStatusMessage('Authorization complete. Closing window...');
    // Close the popup after a short delay
    setTimeout(() => window.close(), 500);
  }, [location.search]);

  return (
    <p style={{ color: hasError ? '#b00020' : '#1f2937', padding: '2rem' }}>
      {statusMessage}
    </p>
  );
}
